import { combineReducers } from "redux";

import dialog from "./dialog";
import location from "./location";
import category from "./category";
import file from "./file";
import validation from "./validation";
import getMonthYearSelected from "./calendar";

const staticReducer = combineReducers({
  dialog,
  location,
  category,
  file,
  validation,
  getMonthYearSelected,
});

export default staticReducer;
